import {
  getObject,
  getOptionalObject,
} from "@surya-digital/leo-ts-types";
import { Code, CodeDTO } from "../types/code";

export interface SurveyRuleTargetDTO {
  questionCode: CodeDTO;
  gridRowCode?: CodeDTO | null;
}

export class SurveyRuleTarget {
  readonly isSurveyRuleTargetSurveyRuleTarget: boolean = true;

  readonly questionCode: Code;
  readonly gridRowCode: Code | null;


  constructor(
  questionCode: Code, 
  gridRowCode: Code | null = null
  ) {
    this.questionCode = questionCode;
    this.gridRowCode = gridRowCode;
  }

  static fromDTO(dto: SurveyRuleTargetDTO): SurveyRuleTarget {
    const questionCode = Code.fromDTO(getObject(dto, "questionCode", InvalidSurveyRuleTargetQuestionCodeError));
    let gridRowCode = getOptionalObject(dto, "gridRowCode");
    if(gridRowCode !== undefined && gridRowCode !== null) {
      gridRowCode = Code.fromDTO(getObject(dto, "gridRowCode", InvalidSurveyRuleTargetGridRowCodeError));
    }
    return new SurveyRuleTarget(
      questionCode,
      gridRowCode
    );
  }

  toDTO(): SurveyRuleTargetDTO {
    const dto: SurveyRuleTargetDTO = {
        questionCode: this.questionCode.toDTO(),
    };
    if (this.gridRowCode !== undefined && this.gridRowCode !== null){
      dto.gridRowCode = this.gridRowCode.toDTO();
    }
    return dto;
  }
  }

SurveyRuleTarget.prototype.toString = function toString(): string {
  return `SurveyRuleTarget(questionCode='${this.questionCode}',gridRowCode='${this.gridRowCode}')`;
};

export class InvalidSurveyRuleTargetError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleTargetError";
  }
}
export class InvalidSurveyRuleTargetQuestionCodeError extends InvalidSurveyRuleTargetError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleTargetQuestionCodeError";
  }
}

export class InvalidSurveyRuleTargetGridRowCodeError extends InvalidSurveyRuleTargetError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyRuleTargetGridRowCodeError";
  }
}
